import { chatQueryKeys as e } from "./useChatQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { adminSupportChatApi as r } from "@maat/api-chat";
//#region src/hooks/useAdminMarkSupportReadMutation.ts
var i = (i) => {
	let a = n();
	return t({
		mutationFn: (e) => r.markRead(i, { last_read_message_id: e }),
		onSuccess: () => {
			a.invalidateQueries({ queryKey: e.adminSupportUnread() });
		}
	});
};
//#endregion
export { i as useAdminMarkSupportReadMutation };
